import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import HeaderTemplate from "../templates/HeaderTemplate";
import { MissionViewShow } from "../organisms/MissionViewShow";
import { getMissions } from "../../services/missionApi";

export default function MissionView() {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMission = async () => {
      const result = await getMissions();
      console.log("取得結果:", result);
      if (result) {
        setData(result);
      } else {
        setError(
          "データ取得に失敗しました。ログインし直すか、設計にご連絡ください。"
        );
      }
    };

    fetchMission();
  }, []);

  if (error) return <p>{error}</p>;
  if (!data) return <p>読み込み中...</p>;

  const handleClick = () => {
    navigate("/missions/new");
  };

  return (
    <div>
      <div>
        <HeaderTemplate />
      </div>

      <Box
        sx={{
          width: "80%",
          margin: "0 auto",
          marginTop: 2,
        }}
      >
        <Box display="flex" justifyContent="flex-end">
          <Button variant="contained" color="primary" onClick={handleClick}>
            新規作成
          </Button>
        </Box>

        <Box
          sx={{
            backgroundColor: "white",
            padding: 1,
            borderRadius: 1,
            marginTop: 2,
          }}
        >
          <MissionViewShow missionsList={data}></MissionViewShow>
        </Box>
      </Box>
    </div>
  );
}
